import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import mainImg from "../../static/media/main.webp";
import logo from "../../static/media/logo.webp";

const HeroHeader = () => {
  return (
    <Box
      id="inicio"
      component={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      sx={{
        position: "relative",
        backgroundImage: `url(${mainImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        minHeight: { xs: "70vh", md: "100vh" },
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        alignItems: "center",
        justifyContent: { xs: "center", md: "space-between" },
        color: "#fff",
        pl: { xs: 0, sm: 0, md: 20 },
        pr: { xs: 0, sm: 0, md: 40 },
        textAlign: { xs: "center", md: "left" },
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "linear-gradient(180deg, rgba(58, 0, 116, 0.45) 0%, rgba(0,0,0,0.7) 100%)",
          zIndex: 1,
        }}
      />

      <Box sx={{ position: "relative", zIndex: 2, maxWidth: "650px", mb: { xs: 3, md: 0 } }}>
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1.6rem", sm: "2rem", md: "2.6rem" },
            lineHeight: 1.1,
            mb: 2,
          }}
        >
          No negociamos la calidad. Creamos piezas de cine con impacto social y 
          soluciones digitales de élite para resultados garantizados
        </Typography>
        <Typography
          variant="h1"
          sx={{
            fontWeight: 400,
            fontSize: { xs: "1rem", sm: "1.2rem", md: "1.3rem" },
            maxWidth: { xs: "80%", md: "650px" },
            mx: { xs: "auto", md: 0 },
          }}
        >
          DobleDx: Donde la producción cinematográfica profesional se encuentra con la estrategia MarTech y el máximo beneficio fiscal del Ecuador
        </Typography>
      </Box>

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="Dobledx Logo"
          sx={{
            width: { xs: 150, sm: 200, md: 250 },
            height: "auto",
            filter: 
            "drop-shadow(0 0 4px rgba(255,255,255,0.9)) drop-shadow(0 0 8px rgba(128,0,255,0.4))",
          }}
        />
      </Box>
    </Box>
  );
};

export default HeroHeader;
